import { render, staticRenderFns } from "./AddEditMail.vue?vue&type=template&id=20c6c142&scoped=true"
import script from "./AddEditMail.vue?vue&type=script&lang=js"
export * from "./AddEditMail.vue?vue&type=script&lang=js"
import style0 from "./AddEditMail.vue?vue&type=style&index=0&id=20c6c142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6c142",
  null
  
)

export default component.exports